import HelenAPI from "@helen/sdk";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from '@material-ui/core/Input';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router-dom";

const styles = theme => ({
  settingFormControl: {
    marginTop: "10%",
    width: "100%",
    maxWidth: 360,
    marginLeft: "auto",
    marginRight: "auto"
  },
  margin: {
    marginTop: theme.spacing.unit,
    width: "100%"
  },
  button: {
    marginTop: 15,
    color: "#009688",
    float: "right"
  },
  linkStyle: {
    textDecoration: "none"
  },
  cssLabel: {
    "&$cssFocused": {
      color: "#009688"
    }
  },
  cssFocused: {},
  cssUnderline: {
    "&:after": {
      borderBottomColor: "#009688"
    }
  },
  select: {
    color: "#009688"
  }
});

class LanguageSelector extends React.Component {
  state = {
    mainLanguageId: "",
    secondaryLanguageId: "",
    succeeded: false,
    invalidMainLanguage: false,
    languages: [],
    loading: true,
    version: {},
    versionSelected: false,
    instances: [],
    instance: ""
  };

  // Fetching the languages to be loaded
  componentDidMount = async () => {
    try {
      const langs = await HelenAPI.getLanguages();
      const insts = await HelenAPI.getInstances();
      if (langs && insts) {
        this.setState({
          languages: langs,
          instances: insts,
          loading: false
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  validateConfig = () => {
    this.validateLanguageSelection();
    this.validateVersion();
  };

  // Validating language selections
  validateLanguageSelection = () => {
    const { mainLanguageId, secondaryLanguageId } = this.state;
    if (!mainLanguageId) {
      this.setState({ invalidMainLanguage: true });
      return;
    }
    this.props.setLanguage({
      mainLanguageId,
      secondaryLanguageId
    });
    this.setState({ succeeded: true });
  };

  getVersion = async function() {
    try {
      const v = await HelenAPI.getLatestVersion();
      if (v) {
        this.setState({version: v});
      }
    } catch (error) {
      console.log(error);
    }
  };

  validateInstance = (value) => {
    if (!value) {
      return;
    }
    HelenAPI.setInstance("start_" + value);
    this.setState({ instance: value });
    this.getVersion();
  }

  // Check that version is available
  validateVersion = () => {
    const { version } = this.state;
    if (!version) return;
    this.props.setVersion({
      version
    });
    if (version.data.version > 0) {
      this.setState({ versionSelected: true});
    }
  };

  // Rendering elelments in language selection screen
  render = () => {
    const { classes } = this.props;
    if (this.state.succeeded && this.state.versionSelected) {
      return <Redirect to="/recorder" />;
    }
    return (
      <div className={classes.settingFormControl}>
        <Typography variant="title" gutterBottom>
          Language
        </Typography>
        <Typography variant="body2" gutterBottom>
          Select your main and secondary language
        </Typography>

        <FormControl
          className={classes.margin}
          error={this.state.invalidMainLanguage}
          disabled={this.state.loading}
        >
          <InputLabel
            FormLabelClasses={{
              root: classes.cssLabel,
              focused: classes.cssFocused
            }}
            htmlFor="main-language"
          >
            Main Language
          </InputLabel>
          <Select
            value={this.state.mainLanguageId}
            onChange={({ target: { value } }) =>
              this.setState({ mainLanguageId: value })
            }
            input={
              <Input              
                classes={{
                  underline: classes.cssUnderline
                }}
              />
            }
          >
            {this.state.languages.map(({ name, id }) => (
              <MenuItem value={id} key={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <br />
        <FormControl className={classes.margin} disabled={this.state.loading}>
          <InputLabel
            FormLabelClasses={{
              root: classes.cssLabel,
              focused: classes.cssFocused
            }}
            htmlFor="secondary"
          >
            Secondary
          </InputLabel>
          <Select
            value={this.state.secondaryLanguageId}
            onChange={({ target: { value } }) =>
              this.setState({ secondaryLanguageId: value })
            }
            input={
              <Input              
                classes={{
                  underline: classes.cssUnderline
                }}
              />
            }
          >
            {this.state.languages.map(({ name, id }) => (
              <MenuItem value={id} key={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <br />
        <Typography variant="title" gutterBottom>
          Instance
        </Typography>
        <Typography variant="body2" gutterBottom>
          Select instance
        </Typography>
        <FormControl className={classes.margin} disabled={this.state.loading}>
          <InputLabel
            FormLabelClasses={{
              root: classes.cssLabel,
              focused: classes.cssFocused
            }}
            htmlFor="instances"
          >
            Instance
          </InputLabel>
          <Select
            value={this.state.instance}
            onChange={({ target: { value } }) =>
              this.validateInstance(value)
            }
            input={
              <Input              
                classes={{
                  underline: classes.cssUnderline
                }}
              />
            }
          >
            {this.state.instances.map(({ phrase, id }) => (
              <MenuItem value={phrase} key={id}>
                {phrase}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <br />

        {this.state.version.data ? (
          <Typography style={{ fontSize: 12 }} variant="body2" gutterBottom>
            Version {this.state.version.data.version} created {new Date(this.state.version.data.created).toLocaleString()}
          </Typography>
        ) : ( this.state.instance.length == 0 ? <Typography></Typography> :
          <Typography style={{ fontSize: 12 }} variant="body2" gutterBottom>
            No version exists, it must be made available from helen's web interface.
          </Typography>
        )}

        <br />
        <Button
          variant="raised"
          className={classes.button}
          onClick={this.validateConfig}
          disabled={this.state.loading}
        >
          Next
        </Button>
        {this.state.loading && (
          <CircularProgress
            className={classes.progress}
            style={{
              color: "#004D40",
              marginLeft: "23%",
              marginTop: "-6%",
              position: "absolute"
            }}
            size={24}
          />
        )}
      </div>
    );
  };
}

LanguageSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  setLanguage: PropTypes.func.isRequired,
  setVersion: PropTypes.func.isRequired
};

export default withStyles(styles)(LanguageSelector);



// WEBPACK FOOTER //
// ./src/components/LanguageSelector.jsx